import { AutocompleteChangeReason, FilterOptionsState, createFilterOptions } from '@mui/material';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../../../../stores/Snackbar.store';
import { isValidEmail } from '../../../../../../../../../utils/validators';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';
import { EmailOptions } from '../types/EmailAutocomplete.types';

const useEmailAutocomplete = (emails: string[], onChangeEmails: (emails: string[]) => void) => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const handleChangeEmails = (
    _: React.ChangeEvent<{}>,
    items: EmailOptions[],
    reason: AutocompleteChangeReason,
  ) => {
    const newEmails = items.map((item) => item.email);

    if (reason === 'selectOption') {
      if (items.length === 0) {
        onChangeEmails(newEmails);

        return;
      }

      const notValidEmail = items.find((option) => !isValidEmail(option.email));

      if (notValidEmail) {
        handleMessage({
          type: 'error',
          message: translate(LangEnum.GLOBAL_INVALID_EMAIL),
        });

        return;
      }
      onChangeEmails(newEmails);
    }

    if (reason === 'removeOption') {
      onChangeEmails(newEmails);
    }

    if (reason === 'clear') {
      onChangeEmails([]);
    }
  };

  const filterOptions = (options: EmailOptions[], params: FilterOptionsState<EmailOptions>) => {
    const filtered = createFilterOptions<EmailOptions>()(options, params);

    if (
      params.inputValue?.length &&
      !filtered.find((option) => option.email === params.inputValue)
    ) {
      filtered.push({
        email: params.inputValue,
        prefix: translate(LangEnum.GLOBAL_ADD),
        id: 'new',
      });
    }

    return filtered;
  };

  const formattedEmails: EmailOptions[] = emails.map((email) => ({ email, id: email }));

  return {
    formattedEmails,
    handleChangeEmails,
    filterOptions,
  };
};

export default useEmailAutocomplete;
